import { render, staticRenderFns } from "./accordionItem.vue?vue&type=template&id=2b36821e&"
import script from "./accordionItem.vue?vue&type=script&lang=js&"
export * from "./accordionItem.vue?vue&type=script&lang=js&"
import style0 from "./accordionItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports